/* eslint-disable class-methods-use-this */
import type { Nullable } from '../types';
import type { EnvironmentManager } from './envManager';

export default class EnvironmentManagerImpl implements EnvironmentManager {
  get isDevelopmentEnv(): boolean {
    const env: string = this.currentEnv();
    return env === 'dev';
  }

  get isStagingEnv(): boolean {
    const env: string = this.currentEnv();
    return env === 'stg';
  }

  get isProductionEnv(): boolean {
    const env: string = this.currentEnv();
    return env === 'prd';
  }

  currentEnv(): string {
    const environment: Nullable<string> = process.env.REACT_APP_ENV;

    if (!environment) {
      throw Error(
        'REACT_APP_ENV variable is missing in your environment file.'
      );
    }

    const availableEnvironments = new Set(['dev', 'stg', 'prd']);

    if (!availableEnvironments.has(environment)) {
      throw Error(
        'REACT_APP_ENV value is not a valid environment value. Available environments are: dev, stg, prd'
      );
    }

    return environment;
  }
}
